import type { InquiryFormTheme } from "./inquiry-profile-schema";

/**
 * The classes that draw a Company's colours over the form (styles.css):
 * `dark` for the black scheme, `accent-<name>` for an accent other than
 * the product's green. Undefined for the product's own look, so a form
 * with no theme carries no class at all — not an empty one.
 *
 * They scope a subtree rather than the document: the Astryx theme sets
 * its own accent on the element it wraps the app in, and a scope inside
 * that wrapper is the one place an override outranks it for everything
 * beneath. `:has(.dark)` rules in styles.css carry the scheme out to the
 * canvas — the overscroll and the scrollbars — from there.
 */
export function companyThemeClassName(
	theme: InquiryFormTheme | undefined,
): string | undefined {
	const classes: string[] = [];
	if (theme?.scheme === "dark") classes.push("dark");
	if (theme !== undefined && theme.accent !== "green") {
		classes.push(`accent-${theme.accent}`);
	}
	return classes.length > 0 ? classes.join(" ") : undefined;
}
